import React from "react";
import { useAuth } from "@/App";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogOut, Coins } from "lucide-react";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    // Навигация към началната страница ПРЕДИ да нулираме user state,
    // за да не позволим на ProtectedRoute да ни пренасочи към /login.
    navigate("/", { replace: true });
    await logout();
  };

  return (
    <header className="sticky top-0 z-50 bg-[#F9F9F7] border-b border-[#E5E5DF] py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo (wordmark вграден в PNG) */}
          <div className="flex items-center">
            <img src="/nutramilo-logo.png" alt="Nutramilo" className="h-10 sm:h-11 w-auto object-contain" />
          </div>

          {/* User Info & Actions */}
          <div className="flex items-center space-x-4">
            {/* User Name */}
            <div className="hidden sm:block text-right">
              <p className="text-sm font-medium text-[#1B2019]">{user?.name}</p>
              <p className="text-xs text-[#5F665C]">{user?.email}</p>
            </div>

            {/* Logout Button */}
            <Button
              variant="ghost"
              size="icon"
              onClick={handleLogout}
              data-testid="logout-btn"
              className="text-[#5F665C] hover:text-[#283618] hover:bg-[#E5E5DF]"
            >
              <LogOut className="w-5 h-5" />
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
}
